import React from 'react'
import { ZuiEwiqDialogContent } from '@zeiss/zui-react'
import { icons } from 'app/constants'
import { useIntl } from 'hooks'
import './index.css'

const Index = ({ title, count, icon }) => {
    const { t } = useIntl()
    const ICON = icons[icon]

    return (
        <div className="patient-file-share-header">
            {ICON && <ICON slot="icon" style={{ color: '#828D9E' }} size="l" />}
            <ZuiEwiqDialogContent slot="arbitrary" style={{ background: 'red' }}>
                <div className="zui-content-area">
                    <div className="share-patient-name">
                        <span>{title}</span>
                    </div>
                    {count && (
                        <div className="share-file-count">
                            <span>
                                {count} {t('files')}
                            </span>
                        </div>
                    )}
                </div>
            </ZuiEwiqDialogContent>
        </div>
    )
}

export default React.memo(Index)
